const serviceLinks = [
  "Thí nghiệm Xi măng",
  "Thí nghiệm Bê tông",
  "Thí nghiệm Cốt liệu",
  "Thí nghiệm Đất",
  "Thí nghiệm Kim loại",
];

const quickLinks = [
  { label: "Trang chủ", href: "#hero" },
  { label: "Giới thiệu", href: "#about" },
  { label: "Dịch vụ", href: "#services" },
  { label: "Năng lực", href: "#capabilities" },
  { label: "Liên hệ", href: "#contact" },
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#0A3D25] text-white">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://static.readdy.ai/image/c43dd3b2b6fbcff1b6e6a251cdbd15c0/b341b5bc3acc6262cf0ddd69c309a9db.jpeg"
                alt="Logo Thuận Phát"
                className="h-12 w-auto object-contain rounded"
              />
              <div>
                <div className="font-bold text-sm">THUẬN PHÁT</div>
                <div className="text-white/60 text-xs">Kỹ Thuật</div>
              </div>
            </div>
            <p className="text-white/65 text-sm leading-relaxed mb-5">
              Phòng thí nghiệm vật liệu xây dựng uy tín hàng đầu tại Đà Nẵng. 
              Chuyên nghiệp – Chính xác – Nhanh chóng.
            </p>
            <div className="flex gap-3">
              {[
                { icon: "ri-facebook-fill", href: "#" },
                { icon: "ri-mail-fill", href: "mailto:thuanphatkt.company@gmail.com" },
                { icon: "ri-phone-fill", href: "tel:02366517174" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-lg hover:bg-[#D4A017] transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 id="footer-menu" className="font-bold text-sm uppercase tracking-widest text-white/80 mb-5">
              <a href="#hero">Điều hướng</a>
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => handleNav(l.href)}
                    className="text-white/65 text-sm hover:text-[#D4A017] transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-xs"></i>
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 id="footer-services" className="font-bold text-sm uppercase tracking-widest text-white/80 mb-5">
              <a href="#services">Dịch vụ</a>
            </h4>
            <ul className="space-y-3">
              {serviceLinks.map((s) => (
                <li key={s}>
                  <button
                    onClick={() => handleNav("#services")}
                    className="text-white/65 text-sm hover:text-[#D4A017] transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-flask-line text-xs"></i>
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 id="footer-contact" className="font-bold text-sm uppercase tracking-widest text-white/80 mb-5">
              <a href="#contact">Liên hệ</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-[#D4A017] shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-sm"></i>
                </div>
                <span className="text-white/65 text-sm leading-relaxed">
                  Số 26 đường Phan Anh, Phường Cẩm Lệ, TP. Đà Nẵng
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-[#D4A017] shrink-0">
                  <i className="ri-phone-line text-sm"></i>
                </div>
                <a href="tel:02366517174" className="text-white/65 text-sm hover:text-white transition-colors">
                  0236.6517174 – 0914.410174
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-[#D4A017] shrink-0">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                <a href="mailto:thuanphatkt.company@gmail.com" className="text-white/65 text-sm hover:text-white transition-colors break-all">
                  thuanphatkt.company@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-[#D4A017] shrink-0">
                  <i className="ri-building-2-line text-sm"></i>
                </div>
                <span className="text-white/65 text-sm">MST: 0401923171</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-white/50 text-xs">
          <span>© 2024 Công ty TNHH Kỹ thuật Thuận Phát. Bảo lưu mọi quyền.created by NH-WEB-DANA.COM</span>
          <span>Phòng Thí Nghiệm Vật Liệu Xây Dựng Công Trình – Đà Nẵng</span>
        </div>
      </div>
    </footer>
  );
}
